import { token } from '@cp/shared/di';

export const PAYMENT_FEATURE = token<() => Promise<unknown>>('dialog/PAYMENT_FEATURE');
